<template>
  <Component
    :is="tag"
    :class="[
      'rounded-2xl border border-primary bg-primary transition-all',
      'hover:border-secondary focus-visible:border-quaternary active:border-tertiary',
      { '!border-fivefold !bg-secondary': disabled },
      { '!border-secondary': active }
    ]"
  >
    <slot />
  </Component>
</template>

<script lang="ts" setup>
import type { Component } from 'vue'

type PropType = {
  tag?: string | Component
  disabled?: boolean
  active?: boolean
}

withDefaults(defineProps<PropType>(), {
  tag: 'div',
  disabled: false
})
</script>
